'use client';

import type { TeamDetail } from '@cabal/shared/domain/session/team/types.js';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export interface SessionTeamConfigVars {
  sessionId: string;
}

export function useSessionTeamConfig(): ActionResult<SessionTeamConfigVars, TeamDetail> {
  const api = useApi();

  return useActionHook<SessionTeamConfigVars, TeamDetail>({
    mutationFn: async ({ sessionId }) => {
      const sessionTeam = await api.sessions.byId(sessionId).team();
      return api.teams.byId(sessionTeam.id).get();
    },
  });
}
